import { API } from "../../../lib/api";

export const FONTS = { serif: "'Liberation Serif', Georgia, serif", sans: "'Liberation Sans', Arial, sans-serif", mono: "'Liberation Mono', monospace" };
const JUST = { l: "flex-start", c: "center", r: "flex-end" };
const ALIGN_Y = { t: "flex-start", m: "center", b: "flex-end" };

const isLight = (hex) => [1, 3, 5].reduce((s, i) => s + parseInt(hex.slice(i, i + 2), 16), 0) > 384;

export function PageText({ pg, scale }) {
  if (!pg.text?.trim()) return null;
  const col = pg.pos[1];
  return (
    <div className="absolute flex pointer-events-none" style={{ inset: `${36 * scale}px`, alignItems: ALIGN_Y[pg.pos[0]], justifyContent: JUST[col] }}>
      <div style={{ width: col === "c" ? "100%" : "62%", padding: `${8.6 * scale}px`, borderRadius: 6 * scale, textAlign: { l: "left", c: "center", r: "right" }[col],
        background: pg.band ? (isLight(pg.color) ? "rgba(0,0,0,0.45)" : "rgba(255,255,255,0.72)") : "transparent", color: pg.color, fontFamily: FONTS[pg.font],
        fontWeight: pg.bold ? 700 : 400, fontSize: `${pg.size_pt * scale}px`, lineHeight: 1.3, whiteSpace: "pre-wrap", overflow: "hidden", maxHeight: "100%" }}>{pg.text}</div>
    </div>
  );
}

export function PageFace({ kind, pg, book, copyright, width, aspect, testId }) {
  const scale = width / (aspect.w * 72);
  const style = { width, height: width * (aspect.h / aspect.w) };
  if (kind === "blank") return <div className="bg-white" style={style} data-testid={testId} />;
  if (kind === "title") return (
    <div className="bg-white relative text-slate-900 flex flex-col items-center" style={style} data-testid={testId}>
      <p className="absolute w-full text-center font-bold px-2" style={{ top: "32%", fontFamily: FONTS.serif, fontSize: Math.min(34, aspect.w * 4) * scale }}>{book.title}</p>
      {book.author && <p className="absolute w-full text-center" style={{ top: "66%", fontFamily: FONTS.serif, fontSize: Math.min(18, aspect.w * 2.2) * scale }}>{book.author}</p>}
    </div>
  );
  if (kind === "copyright") return (
    <div className="bg-white relative text-slate-900" style={style} data-testid={testId}>
      <p className="absolute" style={{ left: 54 * scale, right: 20 * scale, bottom: 72 * scale, fontFamily: FONTS.serif, fontSize: 9 * scale }}>{copyright}</p>
    </div>
  );
  return (
    <div className="bg-white relative overflow-hidden" style={style} data-testid={testId}>
      <img src={`${API}/uploads/${pg.upload_id}/thumb?size=800`} alt="" loading="lazy" className={`absolute inset-0 w-full h-full ${pg.placement === "fill" ? "object-cover" : "object-contain"}`} style={pg.placement === "fit" ? { padding: 36 * scale } : undefined} />
      <PageText pg={pg} scale={scale} />
    </div>
  );
}
